import { Box, Typography } from '@mui/material';
import { FastMovingSkuVersionsDatagrid } from '../../components/DataGrid/FastMovingSku';

export const FastMovingSkuPage = () => {
  return (
    <Box p={3}>
      <Typography variant="h6" fontWeight={600} mb={1}>
        Fast-Moving SKU List
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Upload the product team&apos;s CSV of fast-moving SKUs to power the Smart Suggestions list.
        Only one version can be active at a time.
      </Typography>
      <FastMovingSkuVersionsDatagrid />
    </Box>
  );
};
